import React from "react";
import { useTranslation } from "react-i18next";
import { ICellRendererParams } from "@ag-grid-community/core";

import { TwoLineGridCell } from "../../TransactionsDataGrid/renderers";

import { GridInvoice } from "../../../types";

interface Props extends ICellRendererParams {
  data: GridInvoice;
}

const TypeRenderer = ({ data }: Props) => {
  const { invoiceTarget } = data;
  const { t } = useTranslation();

  return (
    <TwoLineGridCell firstLineData={t(`invoices.type.${invoiceTarget}`)} />
  );
};

export default TypeRenderer;
